import { createModule } from "redux-mvc";

import model from "./model";

import sagasModule from "./sagas";

import DescriptionModule from "Portal/NewPortal/PortalHome/Components/Description";

// cards modules
import TaskCardHomeModule from "Portal/NewPortal/Sections/Home/Cards/Tasks";
import CalendarCardHomeModule from "Portal/NewPortal/Sections/Home/Cards/Calendar";

//Sections Modules
import SessionsSectionModule from "Portal/NewPortal/Sections/Sessions";
import ProfileSectionModule from "Portal/NewPortal/Sections/Profile";
import CalendarSectionModule from "Portal/NewPortal/Sections/Calendar";
import WikiPageViewer from "Portal/NewPortal/Sections/Resources";

import ResourcesFlyOverModule from "Portal/NewPortal/Sections/Resources/FlyOver";
import TasksFlyOverModule from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver";

const module = createModule({
  ...model,
  observedDomains: ["user", "portal", "permissions", "organization"]
});
module.plugModule(DescriptionModule);
//CARDS MODULES
module.plugModule(TaskCardHomeModule);
module.plugModule(CalendarCardHomeModule);

//SECTION MODULES
module.plugModule(SessionsSectionModule);
module.plugModule(ProfileSectionModule);
module.plugModule(CalendarSectionModule);
module.plugModule(WikiPageViewer);

//RESOURCES FLYOVER
module.plugModule(ResourcesFlyOverModule);

// TASKS FLYOVER
module.plugModule(TasksFlyOverModule);

module.setRootSaga(sagasModule);

export default module;
